import { render, staticRenderFns } from "./taken.vue?vue&type=template&id=2c599d5a&"
import script from "./taken.ts?vue&type=script&lang=ts&"
export * from "./taken.ts?vue&type=script&lang=ts&"
import style0 from "./taken.vue?vue&type=style&index=0&id=2c599d5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports